/**
 * Admin selector functions
 */
import { createSelector } from 'reselect';

/**
 * Retrieves the vendor bills state from the global state
 */
const vendorBillsReducer = (state) => state.get('vendorBillsReducer');

/**
 * Retrieves loading state from vendor bills reducer
 */
export const loadingSelector = createSelector(vendorBillsReducer, (state) =>
  state.get('loading'),
);

/**
 * Retrieves error state from vendor bills reducer
 */
export const errorSelector = createSelector(vendorBillsReducer, (state) =>
  state.get('error'),
);

/**
 * Retrieves a vendorBill state from vendor bills reducer
 */
export const vendorBillSelector = createSelector(vendorBillsReducer, (state) =>
  state.get('vendorBill').toJS(),
);

/**
 * Retrieves the vendorBills state from vendor bills reducer
 */
export const vendorBillsSelector = createSelector(vendorBillsReducer, (state) =>
  state.get('vendorBills').toJS(),
);

/**
 * Retrieves count state from vendor bills reducer
 */
export const countSelector = createSelector(vendorBillsReducer, (state) =>
  state.get('count'),
);
